import { DownloadIcon, PDFIcon } from '../../../../../../../assets/icons';
import { ProfileSection, ProfileSections } from '../../components/ProfileSection';
import styles from './style.module.scss';

interface Props {
    resumeFileKey: string | undefined;
    certificateFileKey: string | undefined;
    coverLetterFileKey: string | undefined;
    portfolioFileKey: string | undefined;
    resumeFileKeyLink: string | undefined;
    portfolioFileKeyLink: string | undefined;
    certificateFileKeyLink: string | undefined;
    coverLetterFileKeyLink: string | undefined;
};

export default function UploadedFiles(props: Props) {
    const files = [
        { title: 'Resume', name: props.resumeFileKey, link: props.resumeFileKeyLink },
        { title: 'Portfolio', name: props.portfolioFileKey, link: props.portfolioFileKeyLink },
        { title: 'Cover letter', name: props.coverLetterFileKey, link: props.coverLetterFileKeyLink },
        { title: 'Certificate', name: props.certificateFileKey, link: props.certificateFileKeyLink },
    ];

    return (
        <ProfileSections gap='sm'>
            {files.map(file => <ProfileSection
                key={file.title}
                title={file.title}
                layout='stack'
                action={file.link && <a href={file.link} target='_blank' rel='noreferrer'>
                    <DownloadIcon />
                </a>}
            >
                {file.name
                    ? <div className={styles.file}>
                        <PDFIcon />
                        <span className={styles.file_title}>{file.name}</span>
                    </div>
                    : <span className={styles.noData}>No file.</span>}
            </ProfileSection>)}
        </ProfileSections>
    );
};
